import React from 'react'
import Header from '../../common/Header'
import CommonHeroSection from '../../common/CommonHeroSection'
import CommonBreadcrumb from '../../common/CommonBreadcrumb'
import DynamicTourSection from '../../sections/CommonSection/DynamicToureSection'
import Footer from '../../common/Footer'
import { hyderabadRamojiData } from './tourPackageData'

function HyderabadRamoji() {
    return (
        <>
            <Header />
            <CommonHeroSection title="Hyderabad Ramoji Film City" />
            <CommonBreadcrumb items={["Hyderabad Ramoji Film City"]} />
            <DynamicTourSection {...hyderabadRamojiData} />
            <Footer />
        </>
    )
}

export default HyderabadRamoji